var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"monitoringProviderOdf"},[_c('stack-received'),(_vm.archived)?_c('stack',{attrs:{"directory":_vm.archived,"name":'Archived',"path":'Archived'}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }